module.exports = __webpack_public_path__ + "static/zhao-667a2543a35396f3baa1910c4a505cfc.png";